import { render, staticRenderFns } from "./Instrument_platforms_new.vue?vue&type=template&id=1f451bd8&"
import script from "./Instrument_platforms_new.vue?vue&type=script&lang=js&"
export * from "./Instrument_platforms_new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports